import { render, staticRenderFns } from "./ProfileVerificationModal.vue?vue&type=template&id=2eefb6af&scoped=true&"
import script from "./ProfileVerificationModal.vue?vue&type=script&lang=js&"
export * from "./ProfileVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVerificationModal.vue?vue&type=style&index=0&id=2eefb6af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eefb6af",
  null
  
)

export default component.exports